import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const SendInApp = ({
  height = 24,
  width = 24,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.17157 4.17157C3 5.34315 3 7.22876 3 11V13C3 16.7712 3 18.6569 4.17157 19.8284C5.34315 21 7.22876 21 11 21H13C16.7712 21 18.6569 21 19.8284 19.8284C21 18.6569 21 16.7712 21 13V11C21 7.22876 21 5.34315 19.8284 4.17157C18.6569 3 16.7712 3 13 3H11C7.22876 3 5.34315 3 4.17157 4.17157ZM15.3075 8.25027C14.8935 7.88481 14.2615 7.92421 13.8961 8.33828C13.5306 8.75235 13.57 9.38429 13.9841 9.74975C14.6085 10.3009 15 11.1041 15 12C15 12.8959 14.6085 13.6991 13.9841 14.2503C13.57 14.6157 13.5306 15.2477 13.8961 15.6617C14.2615 16.0758 14.8935 16.1152 15.3075 15.7498C16.3439 14.835 17 13.4935 17 12C17 10.5065 16.3439 9.16499 15.3075 8.25027ZM12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13ZM10.1039 15.6617C9.73845 16.0758 9.10651 16.1152 8.69244 15.7498C7.65607 14.835 7 13.4935 7 12C7 10.5065 7.65607 9.16499 8.69244 8.25027C9.10651 7.88481 9.73845 7.92421 10.1039 8.33828C10.4694 8.75235 10.43 9.38429 10.0159 9.74975C9.39144 10.3009 9 11.1041 9 12C9 12.8959 9.39144 13.6991 10.0159 14.2503C10.43 14.6157 10.4694 15.2477 10.1039 15.6617Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
